import React from 'react';

import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

import useDeviceContext from '../../../../../context/useDeviceContext';

import { isFromMeta } from './helpers';
import MetaDiscountConfirmation from './MetaDiscountConfirmation';
import MetaDiscountOffer from './MetaDiscountOffer';

/**
 * Gates, in order:
 *   1. Mobile Meta traffic — else render nothing. Gating the current-user query
 *      on this keeps ~all (non-mobile, non-Meta) SEO traffic from firing any
 *      request. Reads the page URL; `typeof window` keeps the server render null
 *      (no hydration mismatch). `buildSignupUrl` preserves the UTM so the
 *      post-signup confirmation trip still passes this gate.
 *   2. Auth resolves → confirmation banner (authenticated) or offer (not).
 *   3. Experiment arm (in `MetaDiscountOffer`) → treatment arm sees the offer.
 */
const MetaDiscountSmokeTest = (): JSX.Element | null => {
  const { isMobile } = useDeviceContext();
  const search = typeof window === 'undefined' ? '' : window.location.search;
  const enabled = isMobile && isFromMeta(search);
  const { isAuthenticated } = useCurrentUser({ enabled });

  if (!enabled || isAuthenticated === undefined) {
    return null;
  }

  return isAuthenticated ? <MetaDiscountConfirmation /> : <MetaDiscountOffer />;
};

export default MetaDiscountSmokeTest;
